import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("md_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const apiErrorMessage = (err, fallback) => {
  const status = err?.response?.status;
  const data = err?.response?.data;
  if (data && (data.cloudflare_error || data.error_code)) return fallback;
  const detail = data?.detail;
  if (typeof detail === "string" && detail && !detail.includes("<")) return detail;
  if (!err?.response) return `${fallback} : le serveur n'a pas répondu (réseau ou délai dépassé).`;
  if (status && status >= 500) return `${fallback} : erreur serveur (${status}).`;
  return fallback;
};

export default api;
